import { axiosClient } from '../../services/axiosInstance'
import { clearOfflinePurchasesAttempt } from '../dynamicYield/ingestDyOfflinePurchases'
import { getDyCuid } from '../dynamicYield/upsertDyUserData'
import type { UserDecathlon } from '../../components/account/types'

function readStoredUserDecathlon(): UserDecathlon | null {
  const raw = window.sessionStorage.getItem('user-decathlon')

  if (!raw) return null

  try {
    return JSON.parse(raw) as UserDecathlon
  } catch {
    return null
  }
}

export const logoutUser = async ({ pathname }: { pathname: string }) => {
  const { data: url } = await axiosClient.post(
    `/api/account/logout?returnPath=${pathname}`
  )

  clearOfflinePurchasesAttempt(getDyCuid(readStoredUserDecathlon()))
  window.sessionStorage.removeItem('user-decathlon')
  window.location.href = url
}
